import React from 'react';
import BaseListSlick, { Props as BaseProps } from '../Shared/ListSlick';
import Card from '../Plans/PlanCard/components/PlanCard';
import { UsersitePlansGetManyPlansTypePayload } from '~/models/schema';

export type Props = BaseProps & {
  plans: Array<UsersitePlansGetManyPlansTypePayload>;
};

class PlanListSlick extends BaseListSlick {
  props: Props;

  settings = (theme) => ({
    slidesToShow: 3,
    slidesToScroll: 1,
    infinite: false,
    arrows: true,
    responsive: [
      {
        breakpoint: theme.breakpoints.values.md,
        settings: {
          arrows: false,
        },
      },
      {
        breakpoint: theme.breakpoints.values.sm,
        settings: {
          slidesToShow: 2.25,
          arrows: false,
        },
      },
    ],
  });

  cardPropsGetter = (plan) => ({});

  slickItemsRenderer() {
    const { classes, plans = [] } = this.props;
    return plans.map((plan, index) => (
      <Card
        key={`business-plan-list-slick${index}`}
        fixTermTextLine
        className={classes.card}
        {...plan}
        {...this.cardPropsGetter(plan)}
      />
    ));
  }
}

export default PlanListSlick;
